import { ReactNode } from 'react';
import { PRODUCT_BACKGROUND_CONFIGS } from '../../../../consts';
import { useScrollBackground } from '../../../../hooks/useScrollBackground';

/**
 * Product 섹션들(ZEP, ZEP QUIZ, ZEP SCHOOL)을 감싸는 래퍼 컴포넌트
 * 스크롤에 따라 뷰포트 중앙에 있는 섹션의 배경색으로 자연스럽게 전환됩니다.
 * 그라디언트는 뷰포트에 fixed로 고정되어 콘텐츠만 스크롤됩니다.
 */
export const ProductSectionsWrapper = ({
  children
}: ProductSectionsWrapperProps) => {
  const currentSectionId = useScrollBackground();
  return <div className="relative" style={{
    clipPath: 'inset(0)'
  }} data-sentry-component="ProductSectionsWrapper" data-sentry-source-file="ProductSectionsWrapper.tsx">
      {PRODUCT_BACKGROUND_CONFIGS.map(config => <div key={config.sectionId} className="pointer-events-none fixed inset-0 transition-opacity duration-500 ease-in-out" style={{
      background: `linear-gradient(180deg, ${config.gradientFrom} 0%, ${config.gradientTo} 50%)`,
      opacity: currentSectionId === config.sectionId ? 1 : 0
    }} />)}
      <div className="relative">{children}</div>
    </div>;
};
interface ProductSectionsWrapperProps {
  children: ReactNode;
}